export const API_URL = "https://frp-portalbk.pharus-dev.ru/api/v1/";
export const AUTH_URL = "https://frp-portalbk.pharus-dev.ru/api/v1/auth/openid";
export const IS_DEV_MODE = true;